import './index.css';
import { useState } from 'react';
import TechCallChat from '../TechCallChat';
import { observer } from 'mobx-react';
import CallSessionInformation from '../CallSessionInformation';
import TechCallSessionNotes from '../TechCallSessionNotes';
import strings from '../../localization';
import MainStore from '../../stores/MainStore';

const TechCallSessionInformation = () => {

  const selectedTab = MainStore.sessionInformationSelectedTab;

  const setSelectedTab = (tab) => {
    MainStore.setSessionInformationSelectedTab(tab);
  }

  return (
    <div className="tech-call-session-information">
      <div className="tech-call-session-information-title">
        <span>{strings.sessionInformation} </span>
        <i style={{ fontSize: '13px' }}>version: 0.0.12</i>
      </div>
      <CallSessionInformation />
      <div className="tech-call-session-information-tabs">
        <button className={`tech-call-session-information-button ${selectedTab === 'session-notes' ? 'tech-call-session-information-button-active' : ''}`} onClick={() => setSelectedTab('session-notes')}>
          <span>{strings.sessionNotes}</span>
        </button>
        <button className={`tech-call-session-information-button ${selectedTab === 'chat' ? 'tech-call-session-information-button-active' : ''}`} onClick={() => setSelectedTab('chat')}>
          <span>{strings.chat}</span>
        </button>
      </div>
      {selectedTab === 'session-notes' && <TechCallSessionNotes />}
      {selectedTab === 'chat' && <TechCallChat />}
    </div>
  );
};


export default observer(TechCallSessionInformation);